import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { StorageKey } from '@/models/enums'
import zhCN from './zh-CN'
import zhTW from './zh-TW'
import enUS from './en-US'

const localLanguage = localeFormat(
  new URL(window.location.href).searchParams.get('locale') ||
  storage.getItem(StorageKey.LANGUAGE) ||
  navigator.language,
)
const languageList = ['zh-CN', 'zh-TW', 'en-US']
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  warnHtmlMessage: false,
  locale: languageList.includes(localLanguage) ? localLanguage : 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en-US': enUS,
  },
})

export const useI18n = (app: App) => {
  storage.setItem(StorageKey.LANGUAGE, i18n.global.locale.value)
  app.use(i18n)
}

/**
 * 格式化语言
 * @param locale 语言
 * @returns 格式化后的语言
 */
function localeFormat(locale: string) {
  if (/^zh/.test(locale)) {
    locale = /Hant|TW|HK|MO/i.test(locale) && !/Hans|CN/i.test(locale) ? 'zh-TW' : 'zh-CN'
  } else if (/^en/.test(locale)) {
    locale = 'en-US'
  } else {
    locale = 'en-US'
  }

  return locale.replace(/_/g, '-')
}
